module.exports = __webpack_public_path__ + "media/components/components/booking/KidsSafety/assets/seat-without-belts-flyo-9b862a4eb350e9998f205e323412f501.svg";